export const MARITAL_STATUS_OPTIONS = [
  { value: "SINGLE", label: "أعزب / عزباء" },
  { value: "ENGAGED", label: "خاطب / خاطبة" },
  { value: "MARRIED", label: "متزوج / متزوجة" },
  { value: "SEPARATED", label: "منفصل / منفصلة" },
];

export const MILITARY_STATUS_OPTIONS = [
  { value: "COMPLETED", label: "أدى الخدمة" },
  { value: "EXEMPTED", label: "معفى" },
  { value: "POSTPONED", label: "مؤجل" },
  { value: "NOT_CALLED_YET", label: "لم يُدعَ بعد" },
  { value: "NOT_APPLICABLE", label: "غير مطلوب (أنثى / السن)" },
];

export function maritalStatusLabel(value) {
  return MARITAL_STATUS_OPTIONS.find((o) => o.value === value)?.label || value || "—";
}

export function militaryStatusLabel(value) {
  return MILITARY_STATUS_OPTIONS.find((o) => o.value === value)?.label || value || "—";
}

export const EMPTY_APPLY_FORM = {
  fullName: "",
  email: "",
  phone: "",
  nationalId: "",
  dateOfBirth: "",
  residence: "",
  education: "",
  militaryStatus: "",
  maritalStatus: "",
  previousExperience: "",
  notes: "",
};

export function appendApplyFields(formData, fields) {
  formData.append("fullName", fields.fullName);
  formData.append("email", fields.email);
  formData.append("phone", fields.phone);
  formData.append("nationalId", fields.nationalId);
  formData.append("dateOfBirth", fields.dateOfBirth);
  formData.append("residence", fields.residence);
  formData.append("education", fields.education);
  formData.append("militaryStatus", fields.militaryStatus);
  formData.append("maritalStatus", fields.maritalStatus);
  formData.append("previousExperience", fields.previousExperience);
  if (fields.notes) formData.append("notes", fields.notes);
}
